module.exports = __webpack_public_path__ + "question-mark-386986f9fc3a008158e5b1f84ff01a4e.svg";